class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.header-search__container');
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.closeButton = this.querySelector('.close-icon');
    this.searchButton = this.querySelector('.search-icon');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.closeButton?.addEventListener('click', () => {
      this.close();
    });

    this.searchButton?.addEventListener('click', () => {
      this.submitSearch();
    });
  }

  submitSearch() {
    const searchTerm = this.input.value.trim();
    if (searchTerm.length > 0) {
      this.form.submit();
    }
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.container.classList.remove('visible');
    this.predictiveSearchResults.style.display = 'none';
    this.form.reset();
    document.body.style.overflow = '';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
